export default __webpack_public_path__ + "static/media/printer.fb37c443.png";